import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button, Dialog, Classes
} from '@blueprintjs/core';
import './errors-dialog.scss';

type Props = {
  data: { securityPolicy: string },
  wasSecurityPolicyUpdatedWithErrors: boolean,
}

const ErrorsDialog = ({ data, wasSecurityPolicyUpdatedWithErrors }: Props) => {
  const { t } = useTranslation();
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    setOpen(wasSecurityPolicyUpdatedWithErrors);
  }, [wasSecurityPolicyUpdatedWithErrors]);

  const handleCLose = () => {
    setOpen(false);
  }

  const renderErrorSection = (title: string, error: string) => {
    if (!error) {
      return null;
    }

    return (
      <div className="errors-dialog-section">
        <h5 className="errors-dialog-section-title">{title}:</h5>
        <ul className="errors-dialog-errors">
          <li key={error} className="errors-dialog-errors-item">{error}</li>
        </ul>
      </div>
    );
  }

  return (
    <Dialog isOpen={isOpen} title={t('securityPolicy.form.dialog.title')} onClose={handleCLose} className="errors-dialog">
      <div className="errors-dialog-body">
        <p className="errors-dialog-note">{t('securityPolicy.form.dialog.note')}</p>
        <div className="errors-dialog-sections">
          {renderErrorSection(t('securityPolicy.form.dialog.securityPolicy'), data.securityPolicy)}
        </div>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button onClick={handleCLose} intent="primary" text={t('common.button.ok')} />
        </div>
      </div>
    </Dialog>
  )
}

export default ErrorsDialog;
